import { render, staticRenderFns } from "./Applicationpolice.vue?vue&type=template&id=e335b018&"
import script from "./Applicationpolice.vue?vue&type=script&lang=js&"
export * from "./Applicationpolice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports